import axios from 'axios'
import router from '../router'
import EventBus from './event-bus'
import storageService from './StorageService'

export default {

  user: {
    name: '',
    authorities: [],
    isAdmin: false,
    authenticated: false
  },

  loggedIn () {
    return !!storageService.getItem('access_token')
  },

  isAdmin() {
    return this.user.isAdmin
  },

  login (params, cb) {
    axios.post('/accounts/login', params)
    .then(({data}) => {
      this.loginSuccess(data)
      if (cb) {
        cb(true)
      }
    }, () => {
      if (cb) {
        cb(false)
      }
    })
  },

  register (params) {
    return axios.post('/users', params)
  },

  loginSuccess (data) {
    this.setToken('access_token', data.token)
    this.user.name = data.name
    this.user.authorities = data.authorities
    this.user.isAdmin = data.authorities.map(e => e.authority).includes('ROLE_ADMIN')
    this.user.authenticated = true
    EventBus.$emit('login', this.user)
  },

  getUserInfo: function () {
    let token = this.getAccessToken()

    if (typeof token === 'undefined' || token === null || token === '') {
      return false
    }

    axios.get('/accounts/principal').then(({ data }) => {
      this.user = data
      this.user.isAdmin = data.authorities.map(e => e.authority).includes('ROLE_ADMIN')
      EventBus.$emit('login', this.user)
    })
  },

  checkAuth () {
    this.getUserInfo()
  },

  logout () {
    const token = this.getAccessToken()

    if (token) {
      console.log('user ' + this.user.name + ' logout')
      this.user.name = ''
      this.user.authorities = []
      this.user.isAdmin = false
      this.user.authenticated = false

      storageService.removeItem('access_token')
      EventBus.$emit('login', {})
      router.push('/')
    }
  },

  getAccessToken () {
    return storageService.getItem('access_token')
  },

  setToken (key, token) {
    storageService.setItem(key, token)
  }

}
